<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <form>
      <div class="suggestions-img-box">
        <div>
          <img :src="formData.picture1" alt="" v-if="formData.picture1" class="suggestions-img" @click="showImg(formData.picture1)">
          <img src="../../assets/noImg.jpg" alt="" v-else class="suggestions-img">
        </div>
        <div>
          <img :src="formData.picture2" alt="" v-if="formData.picture2" class="suggestions-img" @click="showImg(formData.picture2)">
        </div>
        <div>
          <img :src="formData.picture3" alt="" v-if="formData.picture3" class="suggestions-img" @click="showImg(formData.picture3)">
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>姓名：</span>
          </div>
          <el-input v-model="formData.personName" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>手机号：</span>
          </div>
          <el-input v-model="formData.personPhone" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>房间号：</span>
          </div>
          <el-input v-model="formData.roomNumber" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>住户名称：</span>
          </div>
          <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>类型：</span>
          </div>
          <el-input v-model="formData.type" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>内容：</span>
          </div>
          <el-input type="textarea" v-model="formData.content" size="small" style="width: 280px" :rows="5" disabled />
        </div>
        <div class="form-line">
          <div class="line-text">
            <b class="red">*</b>
            <span>提交时间：</span>
          </div>
          <el-input v-model="formData.createTime" size="small" style="width: 280px" disabled />
        </div>

        <div class="form-line">
          <div class="line-text">
            <!--<b class="red">*</b>-->
            <span>处理情况：</span>
          </div>
          <el-input type="textarea" v-model="formData.memo" size="small" style="width: 280px" :disabled="formData.status === '1'" :rows="3" />
        </div>

        <div class="form-btn-box">
          <button-confirm @confirm="confirm" value="确定" v-if="formData.status === '0'" style="margin-right: 120px;" />
          <button-cancel @cancel="cancelApply" value="返回" />
        </div>
      </div>
    </form>

    <el-dialog
      :visible.sync="dialogVisible"
      width="50%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { api } from "../api/User";
import { errorHandler } from "../../utils/errorHandler";
import ButtonConfirm from "../../components/Button/ButtonConfirm";
import { nSuccess } from "../../utils/notice";
import ButtonDeleteData from "../../components/Button/ButtonDelete";
import ButtonCancel from "../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    ButtonDeleteData,
    ButtonConfirm,
    Breadcrumb
  },
  name: "suggestions-details",
  data() {
    return {
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval"
        },
        {
          value: "投诉建议"
        }
      ],

      currentCode: "",
      formData: {
        type: "",
        content: "",
        picture1: "",
        picture2: "",
        picture3: "",
        personName: "",
        personPhone: "",
        personCode: "",
        createTime: "",
        memo: ""
      },

      dialogVisible: false,
      lookOverImg: ""
    };
  },
  created() {
    this.currentCode = this.$route.params.id;
    this.getSuggestionsByCode();
  },
  methods: {
    toNeedHandlePage() {
      this.$router.push({
        name: "suggestion-approval"
      });
    },
    getSuggestionsByCode() {
      this.$axios
        .get(`${api.getSuggestionsByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.createTime = data.createTime.slice(0, 19);
            this.formData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    confirm() {
      this.formData.status = "1";
      this.$axios
        .post(api.changeSuggestionsStatus, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toNeedHandlePage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancelApply() {
      this.toNeedHandlePage();
    },
    showImg(imgUrl) {
      this.dialogVisible = true;
      this.lookOverImg = imgUrl;
    }
  },
  watch: {
    dialogVisible() {
      if (!this.dialogVisible) {
        this.lookOverImg = "";
      }
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
  display: flex;
  justify-content: flex-start;
}
.form-line {
  margin: 20px 0;
  display: flex;
  line-height: 32px;
  justify-content: flex-start;
}
.red {
  color: #ff0000;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 80px;
  text-align: right;
}
.suggestions-img-box {
  padding: 20px 0;
  width: 300px;
  height: 640px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.suggestions-img {
  cursor: pointer;
  display: block;
  margin: 0 auto;
  max-width: 300px;
  height: 120px;
}
.form-btn-box {
  width: 460px;
  padding: 0 90px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/view/User/SuggestionsDetail.vue